<template>
    <div>
        <div class="flex items-center space-x-2">
            <button v-if="!playing" @click="play()" class="focus:outline-none">
                <alo-icon icon="solid-play" class="w-8 h-8" />
            </button>
            <button v-if="playing" @click="pause()" class="focus:outline-none">
                <alo-icon icon="solid-pause" class="w-8 h-8" />
            </button>

            <div class="w-48">
                <div class="mt-5 w-full bg-white h-1 rounded-full">
                    <div
                        v-if="duration > 0"
                        class="bg-primary-400 h-1 rounded-full"
                        :style="'width:' + (currentTime / duration) * 100 + '%'"
                    ></div>
                </div>

                <div class="mt-1 text-sm">
                    {{ duraçãoFormatada }}
                </div>
            </div>
        </div>

        <div
            v-show="loadingTranscription && !transcriptionText"
            class="flex items-center space-x-1 p-1 text-sm opacity-75"
        >
            <alo-icon icon="outline-refresh" class="animate-spin w-4 h-4" />
            <span>{{ __('Gerando transcrição...') }}</span>
        </div>

        <div v-show="transcriptionText" class="mt-2">
            <div class="font-bold text-sm opacity-75">{{ __('Transcrição automática') }}</div>
            {{ transcriptionText }}
        </div>
    </div>
</template>

<script>
import { pad } from '@Shared/Date'
import axios from 'axios'

export default {
    props: ['src', 'anexo', 'eventId', 'transcription'],
    data() {
        return {
            playing: false,
            currentTime: 0,
            duration: 0,
            loadingTranscription: false,
        }
    },
    computed: {
        duraçãoFormatada() {
            if (this.duration == Infinity) return '--'

            let minutos = Math.floor(this.duration / 60)
            let segundos = Math.ceil(this.duration - minutos * 60)

            return pad(minutos) + ':' + pad(segundos)
        },

        transcriptionText() {
            return this.anexo.atributos_extras.transcription
        },
    },
    mounted() {
        this.audio = new Audio(this.src)
        this.audio.addEventListener('timeupdate', () => {
            this.currentTime = this.audio.currentTime

            if (this.currentTime >= this.duration) {
                this.audio.currentTime = 0
                this.currentTime = 0
                this.pause()
            }
        })

        this.audio.addEventListener('durationchange', () => {
            this.duration = this.audio.duration
        })

        this.audio.load()

        if (this.anexo.atributos_extras.transcription === undefined && this.transcription !== false) {
            if (this.$store.state.usuário && this.$store.state.usuário.cliente.plan_audio_transcription) {
                this.loadTranscription()
            }
        }

        setTimeout(() => {
            this.audio.currentTime = 999999
        }, 100)
    },
    methods: {
        loadTranscription() {
            if (!this.eventId) return
            this.loadingTranscription = true

            axios.post(route('/api/core/files/audio_transcriptions'), {
                file_id: this.anexo.id,
                event_id: this.eventId,
            })
        },
        play() {
            this.playing = true
            this.audio.play()
        },
        pause() {
            this.playing = false
            this.audio.pause()
        },
    },
}
</script>